export default __webpack_public_path__ + "src/images/brand_deals-a7d03e65c0a69428f6bad76869f237ae.jpg";